import { ApiProvider, createQueryClient } from '@legalcrm/api';
import { ToastProvider } from '@legalcrm/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { RouterProvider } from 'react-router-dom';

import { apiClient } from '@/api/client';
import { router } from '@/routes/router';
import { ThemeProvider } from '@/shell/theme';

/**
 * Provider order matters.
 *
 * QueryClient outermost, because `AuthProvider` uses it to clear the cache on sign-in
 * and sign-out — a tenant's data must not survive a switch of firm. Router innermost,
 * because `AuthProvider` is mounted inside the route tree (see `router.tsx`) so that
 * `useNavigate` is available to it.
 */
export function App() {
  // Created once per mount rather than at module scope: a module-level client is
  // shared across tests and leaks one test's cache into the next.
  const [queryClient] = useState(() => createQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <ApiProvider client={apiClient}>
        <ThemeProvider>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </ThemeProvider>
      </ApiProvider>
    </QueryClientProvider>
  );
}
